import { render, staticRenderFns } from "./shipApproval.vue?vue&type=template&id=0dc2c0c6&scoped=true"
import script from "./shipApproval.vue?vue&type=script&lang=js"
export * from "./shipApproval.vue?vue&type=script&lang=js"
import style0 from "./shipApproval.vue?vue&type=style&index=0&id=0dc2c0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc2c0c6",
  null
  
)

export default component.exports